import {
  ImageHelper,
  type IProductModel,
  type ITextComponentWithAssetsModel,
} from "@nf/common";
import dynamic from "next/dynamic";

import LandingPageHeroSection from "components/LandingPage/LandingPageHeroSection";
import LandingPageBrand from "components/LandingPage/LandingPageBrand";

import { LANDING_PAGE_COMPONENT_SUB_TYPE } from "@nf/common/src/providers/DataProvider/RedBeeMedia/constants";
import type { ILandingPageHeroComponent } from "../types";

import styles from "./LandingPageHero.module.scss";

const LandingPageOffers = dynamic(
  () => import("components/LandingPage/LandingPageOffers")
);

interface LandingPageHeroProps {
  component: ITextComponentWithAssetsModel;
  offers?: IProductModel[];
}

const LandingPageHero = ({ component, offers }: LandingPageHeroProps) => {
  const { sub_type } =
    component.TextParsed as unknown as ILandingPageHeroComponent;

  const backgroundImage = ImageHelper.getHighlightsImageUrl(
    component.MediaList?.[0]?.Images,
    null
  );

  return (
    <div className={styles.container}>
      <LandingPageHeroSection image={backgroundImage}>
        <LandingPageBrand>
          {/* TODO translation */}
          Største udvalg af danske film
        </LandingPageBrand>

        {sub_type === LANDING_PAGE_COMPONENT_SUB_TYPE.OFFERS && offers && (
          <LandingPageOffers offers={offers} />
        )}
      </LandingPageHeroSection>
    </div>
  );
};

export default LandingPageHero;
